import Check from '@mui/icons-material/Check';
import React from 'react';

const BooleanCellRenderer = (props: any) => {
    return props.value || props.value === 'true' ? <Check></Check> : null;
};

export default BooleanCellRenderer;
